import { JobSearchQueryInput } from '@xing-com/crate-common-graphql-types';
import { JDP_SA_DEFAULT_QUERY } from '@xing-com/crate-jobs-constants';

import { useNavigationState } from './use-navigation-state';

export const useSearchAlertParams = (): JobSearchQueryInput | undefined => {
  const state = useNavigationState();
  return state && state[JDP_SA_DEFAULT_QUERY];
};
